function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import position from 'polished/lib/shorthands/position';
import { useTheme } from '@veneer/theme';
import React from 'react';
import highContrastMediaQuery from '../utils/high_contrast_media_query';
export var useStyles = _ref => {
  var {
    appearance,
    gutter
  } = _ref;
  var theme = useTheme();
  return React.useMemo(() => ({
    container: _extends({
      borderColor: appearance === 'outlined' || gutter ? 'transparent' : theme.palette.stroke.default,
      borderRadius: theme.borderRadius4,
      borderStyle: 'solid'
    }, appearance === 'outlined' && !gutter && {
      borderColor: theme.palette.stroke.default,
      borderRadius: theme.borderRadius4
    }, appearance === 'dropShadow' && !gutter && {
      boxShadow: theme.level.level4
    }, highContrastMediaQuery(theme))
  }), [theme, gutter, appearance]);
};
export var useItemStyles = _ref2 => {
  var {
    appearance,
    disabled,
    gutter,
    isExpanded,
    isFirst,
    isFocused,
    isLast
  } = _ref2;
  var theme = useTheme();
  return React.useMemo(() => ({
    chevron: _extends({
      fill: disabled ? theme.palette.foreground.disabled : theme.palette.foreground.default,
      flex: '0 0 auto',
      transform: 'rotate(0)',
      transition: 'transform 0.5s ease',
      pointerEvents: 'none'
    }, isExpanded && {
      transform: 'rotate(-180deg)'
    }),
    content: _extends({
      border: 0,
      boxSizing: 'border-box',
      color: disabled ? theme.palette.foreground.disabled : theme.palette.foreground.light,
      margin: "0px ".concat(theme.orbitalFour),
      overflow: 'hidden',
      padding: "".concat(theme.orbitalFour, " 0px")
    }, isExpanded && {
      border: "solid ".concat(theme.palette.stroke.default),
      borderWidth: '1px 0px 0px'
    }),
    header: {
      alignItems: 'center',
      backgroundColor: 'transparent',
      border: 0,
      cursor: 'pointer',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      padding: theme.orbitalThree,
      position: 'relative',
      '&::before': _extends({
        border: "2px solid ".concat(theme.palette.primary.default),
        borderRadius: theme.borderRadius4,
        content: "' '",
        opacity: 0,
        transition: 'all 50ms'
      }, position('absolute', 0), theme.mode === 'contrast' && {
        border: "2px solid ".concat(theme.palette.primary.active)
      }, isFocused && {
        borderRadius: "calc(".concat(theme.borderRadius4, " + 2px)"),
        opacity: 1
      })
    },
    headerItem: {
      alignItems: 'center',
      color: theme.palette.foreground.default,
      display: 'inline-flex',
      paddingRight: theme.orbitalThree,
      marginLeft: 'auto'
    },
    previewArea: {
      margin: "0px ".concat(theme.orbitalFour),
      padding: "".concat(theme.orbitalFour, " 0px")
    },
    item: _extends({
      backgroundColor: appearance === 'outlined' ? 'transparent' : theme.palette.background.container,
      borderColor: 'transparent',
      borderRadius: theme.borderRadius4,
      borderStyle: 'solid',
      borderWidth: '0px 1px 0px',
      boxSizing: 'border-box'
    }, (isFirst || gutter) && {
      borderTopWidth: '1px'
    }, !isFirst && !gutter && {
      borderTopColor: theme.palette.stroke.default,
      borderTopWidth: '1px'
    }, isLast && {
      borderBottomWidth: '1px',
      borderLeftWidth: '1px',
      borderRightWidth: '1px'
    }, {
      display: 'flex',
      flexDirection: 'column',
      marginBottom: gutter,
      overflow: 'hidden'
    }, gutter && appearance === 'dropShadow' && {
      boxShadow: theme.level.level4
    }, gutter && {
      borderBottomWidth: '1px'
    }, !gutter && {
      borderRadius: 0,
      '&:first-of-type': {
        borderTopLeftRadius: theme.borderRadius4,
        borderTopRightRadius: theme.borderRadius4
      },
      '&:last-of-type': {
        borderBottomLeftRadius: theme.borderRadius4,
        borderBottomRightRadius: theme.borderRadius4
      }
    }, appearance === 'outlined' && {
      borderColor: theme.palette.stroke.default
    }, theme.mode === 'contrast' && {
      borderColor: theme.palette.primary.default
    }),
    title: {
      color: disabled ? theme.palette.foreground.disabled : theme.palette.foreground.default,
      flexGrow: 1
    }
  }), [appearance, disabled, gutter, isExpanded, isFirst, isFocused, isLast, theme]);
};